import React from 'react';
import styles from './CustomNoRowsTemplate.module.css';
import CheckMarkIcon from '../../../assets/SVGs/checkmark.svg';
import { STORE_DRILL_DOWN_NO_DATA } from '../../../constants/constant';
const StoreDrilldownRowOverlay = () => {
	return (
		<div role="presentation" className={`ag-overlay-loading-center`}>
			<div>
				<img
					src={CheckMarkIcon}
					alt="No stores found for with replenishment for Selected week filter!"
				/>
			</div>

			<div className={styles.mainTitle}>{STORE_DRILL_DOWN_NO_DATA}</div>
		</div>
	);
};
export default StoreDrilldownRowOverlay;
